// extracted by mini-css-extract-plugin
export default {"root":"TextBadge_root__ExVo7","button":"TextBadge_button__ErqvW"};